import Button from "core/buttons/button/Button";
import { ACTIONS, ENTITIES } from "constants/constants";
import { FormattedMessage } from "react-intl";
import { HandleModaleBO } from "components/bo/HandleModaleBO";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TableManager } from "components/bo/admin-table/TableManager";
import { navigateView, navigateEdit, navigateToParent } from "utils/boHelper";
import { useCurrencyContext } from "api/settings/currency/CurrencyProvider";
import { useEffect, useState } from "react";
import { useUserContext } from "api/user/UserProvider";

export default function AdminCurrency({ action }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const {
    currencyByIdGetter,
    currencyCreate,
    currencyDeleteById,
    currencyList,
    currencyListGetter,
    currencyPerId,
    currencyUpdateById,
  } = useCurrencyContext();
  const { userScope } = useUserContext();

  const currencyForm = [
    {
      col: "currency_name",
      mandatory: true,
      isMissingValue: null,
      editable: true,
    },
    {
      col: "currency_id",
      mandatory: true,
      isMissingValue: null,
      editable: true,
    },
    {
      col: "currency_symbol",
      mandatory: true,
      isMissingValue: null,
      editable: true,
    },
  ];

  const [deleteData, setDeleteData] = useState(null);

  useEffect(() => {
    currencyListGetter();
  }, [currencyListGetter]);

  useEffect(() => {
    if (id) {
      currencyByIdGetter(id);
    }
  }, [id]);
  const handleDelete = async (currencyId) =>
    setDeleteData(currencyList.find((e) => e.id === currencyId));

  const validateDelete = async (currencyId) => {
    try {
      await currencyDeleteById(currencyId);
    } catch (error) {
      console.error(error);
    }
  };
  const handleCreate = (payload) => {
    try {
      currencyCreate(payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  const handleEdit = (payload) => {
    try {
      currencyUpdateById(payload.id, payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };

  // Todo gestion droits admin
  return (
    <div>
      <div>
        {action === ACTIONS.LIST && (
          <div className="flex">
            <Button
              className="btn-hover-color"
              size="large"
              color="blue"
              onClick={() => navigateView("new", navigate, location)}
            >
              <FormattedMessage
                id={"admin_create_new"}
                defaultMessage={"Nouveau"}
              />
            </Button>
          </div>
        )}
        <br />
        <TableManager
          action={action}
          entity={ENTITIES.CURRENCY}
          entityPerId={currencyPerId}
          list={currencyList}
          inputs={currencyForm}
          navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
          navigateView={(propsId) => navigateView(propsId, navigate, location)}
          handleCreate={handleCreate}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
        />

        <div id="modalDelete">
          <HandleModaleBO
            setDeleteData={setDeleteData}
            validateDelete={validateDelete}
            deleteData={deleteData}
            entity={ENTITIES.CURRENCY}
          />
        </div>
      </div>
    </div>
  );
}
